import { BadgeCheck } from "lucide-react";
import { useEffect, useState, type FormEvent } from "react";
import { useSearchParams } from "react-router-dom";
import { Button, ButtonLink, Input } from "../../design-system";
import { apiFetch, errorMessage } from "../../lib/api";

export function AcceptInvitationPage() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const [password, setPassword] = useState("");
  const [termsVersion, setTermsVersion] = useState("terms-2026-01");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    apiFetch<{ termsDocumentVersion: string }>("/auth/config", {
      skipRefresh: true,
    })
      .then((v) => setTermsVersion(v.termsDocumentVersion))
      .catch(() => undefined);
  }, []);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      await apiFetch("/auth/partners/accept-invitation", {
        method: "POST",
        body: { token, password, acceptedTermsVersion: termsVersion },
        skipRefresh: true,
      });
      setDone(true);
    } catch (cause) {
      setError(errorMessage(cause));
    } finally {
      setLoading(false);
    }
  }

  if (done)
    return (
      <div className="auth-form-card">
        <span className="auth-role-icon auth-role-icon--success">
          <BadgeCheck />
        </span>
        <h2>Conta ativada!</h2>
        <p>
          Seu acesso está pronto. Agora você já pode entrar e compartilhar seu
          link.
        </p>
        <ButtonLink to="/parceiro/entrar">Entrar no portal</ButtonLink>
      </div>
    );
  return (
    <div className="auth-form-card">
      <span className="eyebrow">Convite da clínica</span>
      <h2>Ative sua conta</h2>
      <p>Defina sua senha para acessar o portal do indicador.</p>
      {!token && (
        <div className="alert alert--error">
          Este convite não possui um token válido.
        </div>
      )}
      {error && (
        <div className="alert alert--error" role="alert">
          {error}
        </div>
      )}
      <form className="form-stack" onSubmit={submit}>
        <Input
          label="Nova senha"
          type="password"
          minLength={10}
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          hint="Use pelo menos 10 caracteres."
        />
        <label className="check-row">
          <input type="checkbox" required />
          <span>Aceito os termos e a política de privacidade vigentes.</span>
        </label>
        <Button type="submit" loading={loading} disabled={!token}>
          Ativar minha conta
        </Button>
      </form>
    </div>
  );
}
